import React from "react";
import "../styles/MegaMenuServices.css";
import { Link } from "react-router-dom";

const MegaMenuServices = ({ scrolled }) => {
  return (
    <div className={`mega-menu-services ${scrolled ? 'mega-menu-services--scrolled' : ''}`}>
      <div className="mega-menu-services-group">
        <div className="mega-menu-services-section">
          <h2>Technology</h2>
          <Link to="/services#blockchain-details">Blockchain-Based Solutions</Link>
          <Link to="/services#ai-ml-details">AI & ML Products</Link>
          <Link to="/services#embedded-iot-details">Embedded Systems and IOT</Link>
          <Link to="/services#data-science-details">Data Science</Link>
        </div>
      </div>
    </div>
  );
};

export default MegaMenuServices;
